import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import CookieManager from "../../services/CookieManager";
import { ErrorToast } from "../../pure-components/CustomToast";
import { toast } from "react-toastify";
import Helper from "../../services/helper";
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import logo from "../../assets/logo.png"
import Constants from "../../services/constants";

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { ReactComponent as Download } from '../../assets/downloadLic.svg';
const paymentData = [
  {
    trans_date: "04/06/2025 16:20:15",
    bin_country: "INDIA",
    mer_amount: "1.00",
    order_id: "68401ec02bb53e3cd71ab20b-pi-612053",
    tracking_id: "113792768151",
    bank_ref_no: "T72501",
    order_status: "Success",
    failure_message: "",
    payment_mode: "Credit Card",
    card_name: "MasterCard",
    status_code: "null",
    status_message: "SUCCESS",
    currency: "INR",
    amount: "1.00",
    billing_name: "test",
    billing_address: "Test Address",
    billing_city: "Mumbai",
    billing_state: "Maharashtra",
    billing_zip: "400001",
    billing_country: "India",
    billing_tel: "1234567890",
    billing_email: "test_01@gmail.com",
    delivery_name: "test",
    delivery_address: "Test Delivery Address",
    delivery_city: "Mumbai",
    delivery_state: "Maharashtra",
    delivery_zip: "400001",
    delivery_country: "India",
    delivery_tel: "1234567890",
  },
  {
    trans_date: "03/06/2025 14:05:10",
    bin_country: "INDIA",
    mer_amount: "250.00",
    order_id: "123abc-pi-90283",
    tracking_id: "9988776655",
    bank_ref_no: "A18273",
    order_status: "Aborted",
    failure_message: "User cancelled",
    payment_mode: "UPI",
    card_name: "",
    status_code: "A01",
    status_message: "Transaction was aborted by user",
    currency: "INR",
    amount: "250.00",
    billing_name: "Ravi Kumar",
    billing_address: "Plot 4, Sector 21",
    billing_city: "Delhi",
    billing_state: "Delhi",
    billing_zip: "110001",
    billing_country: "India",
    billing_tel: "9811123456",
    billing_email: "ravi@example.com",
    
    delivery_zip: "110001",
    delivery_country: "India",
    delivery_tel: "9811123456",
  },
  {
    trans_date: "04/06/2025 16:20:15",
    bin_country: "INDIA",
    mer_amount: "1.00",
    order_id: "68401ec02bb53e3cd71ab20b-pi-612053",
    tracking_id: "113792768151",
    bank_ref_no: "T72501",
    order_status: "Success",
    failure_message: "",
    payment_mode: "Credit Card",
    card_name: "MasterCard",
    status_code: "null",
    status_message: "SUCCESS",
    currency: "INR",
    amount: "1.00",
    billing_name: "test",
    billing_address: "Test Address",
    billing_city: "Mumbai",
    billing_state: "Maharashtra",
    billing_zip: "400001",
    billing_country: "India",
    billing_tel: "1234567890",
    billing_email: "test_01@gmail.com",
    delivery_name: "test",
    delivery_address: "Test Delivery Address",
    delivery_city: "Mumbai",
    delivery_state: "Maharashtra",
    delivery_zip: "400001",
    delivery_country: "India",
    delivery_tel: "1234567890",
  },
  {
    trans_date: "03/06/2025 14:05:10",
    bin_country: "INDIA",
    mer_amount: "250.00",
    order_id: "123abc-pi-90283",
    tracking_id: "9988776655",
    bank_ref_no: "A18273",
    order_status: "Aborted",
    failure_message: "User cancelled",
    payment_mode: "UPI",
    card_name: "",
    status_code: "A01",
    status_message: "Transaction was aborted by user",
    currency: "INR",
    amount: "250.00",
    billing_name: "Ravi Kumar",
    billing_address: "Plot 4, Sector 21",
    billing_city: "Delhi",
    billing_state: "Delhi",
    billing_zip: "110001",
    billing_country: "India",
    billing_tel: "9811123456",
    billing_email: "ravi@example.com",
    
    delivery_zip: "110001",
    delivery_country: "India",
    delivery_tel: "9811123456",
  },
  {
    trans_date: "04/06/2025 16:20:15",
    bin_country: "INDIA",
    mer_amount: "1.00",
    order_id: "68401ec02bb53e3cd71ab20b-pi-612053",
    tracking_id: "113792768151",
    bank_ref_no: "T72501",
    order_status: "Success",
    failure_message: "",
    payment_mode: "Credit Card",
    card_name: "MasterCard",
    status_code: "null",
    status_message: "SUCCESS",
    currency: "INR",
    amount: "1.00",
    billing_name: "test",
    billing_address: "Test Address",
    billing_city: "Mumbai",
    billing_state: "Maharashtra",
    billing_zip: "400001",
    billing_country: "India",
    billing_tel: "1234567890",
    billing_email: "test_01@gmail.com",
    delivery_name: "test",
    delivery_address: "Test Delivery Address",
    delivery_city: "Mumbai",
    delivery_state: "Maharashtra",
    delivery_zip: "400001",
    delivery_country: "India",
    delivery_tel: "1234567890",
  },
  {
    trans_date: "03/06/2025 14:05:10",
    bin_country: "INDIA",
    mer_amount: "250.00",
    order_id: "123abc-pi-90283",
    tracking_id: "9988776655",
    bank_ref_no: "A18273",
    order_status: "Aborted",
    failure_message: "User cancelled",
    payment_mode: "UPI",
    card_name: "",
    status_code: "A01",
    status_message: "Transaction was aborted by user",
    currency: "INR",
    amount: "250.00",
    billing_name: "Ravi Kumar",
    billing_address: "Plot 4, Sector 21",
    billing_city: "Delhi",
    billing_state: "Delhi",
    billing_zip: "110001",
    billing_country: "India",
    billing_tel: "9811123456",
    billing_email: "ravi@example.com",
    
    delivery_zip: "110001",
    delivery_country: "India",
    delivery_tel: "9811123456",
  },
];

const getStatusClass = (status) => {
  switch (status) {
    case "Success":
      return "bg-green-500 text-white";
    case "Aborted":
      return "bg-yellow-500 text-white";
    case "Invalid":
      return "bg-red-500 text-white";
    default:
      return "bg-gray-500 text-white";
  }
};

const PaymentHistory = (props) => {
  const history = useHistory();
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const downloadInvoice = async(paymentRef) => {
    const xAccessToken = CookieManager.getCookie("x-access-token");
    const profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}"); 
    if(!profileData || !profileData?.email || profileData?.email?.length === 0){
        toast(({ closeToast }) => <ErrorToast message={"User profile loading error, Please login again."} />);
        history.push("/login");
        return;
    }
    await fetch(`http://localhost:4000/api/users/invoicePDF/${props.subData.id}/${paymentRef}`, 
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': xAccessToken,
                'x-auth': xAccessToken,
                'userId': Helper.encode(profileData.email)
            }
        }
      )
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Invoice-${props.subData.id}-${paymentRef}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((err) => {
        console.error("Download error", err);
        toast(({ closeToast }) => <ErrorToast message={"Invoice download error."} />);
      });
  };

  const generatePDF = async (paymentRef) => {
    const data = props.paymentData[paymentRef];
    data.company_address = Constants.ORG_ADDRESS;
    

    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595, 842]);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const { width } = page.getSize();
    let y = 800;

    const logoImage = await pdfDoc.embedPng(logo);

    const drawText = (text, x, y, size = 10, opts = {}) =>
      page.drawText(text, { x, y, size, font, ...opts });

    const drawBoldText = (text, x, y, size = 10, opts = {}) =>
      page.drawText(text, { x, y, size, font: boldFont, ...opts });
    // Header
    
    // Blue header band
    // page.drawRectangle({ x: 0, y: 810, width, height: 20, color: rgb(0.3, 0.5, 0.8) });

    page.drawImage(logoImage, {
      x: 450,
      y: 750,
      width: 80,
      height: 40,
    });

    y = 780;
    drawBoldText(data.company_address.name, 50, y);
    y -= 15;
    drawText(data.company_address.address1, 50, y);
    y -= 15;
    drawText(data.company_address.address2, 50, y);
    y -= 15;
    drawText(`CIN : ${data.company_address.cin}`, 50, y);
    y -= 15;
    drawText(`GST : ${data.company_address.gst}`, 50, y);


    // Bill to & Invoice details
    y -= 30;
    drawBoldText('BILL TO', 50, y);
    data.delivery_name && drawBoldText('SHIP TO', 200, y);
    drawBoldText('INVOICE #', 370, y);

    y -= 15;
    drawText(data.billing_name, 50, y);
    data.delivery_name && drawText(data.delivery_name, 200, y);
    drawText(data.order_id, 370, y);

    y -= 15;
    drawText(`${data.billing_address}`, 50, y);
    data.delivery_address && drawText(`${data.delivery_address}`, 200, y);
    drawText(`Tracking ID : ${data.tracking_id}`, 370, y);

    y -= 15;
    drawText(`${data.billing_city}, ${data.billing_state}`, 50, y);
    data.delivery_address && drawText(`${data.delivery_city}, ${data.delivery_state}`, 200, y);
    drawText(`Invoice Date : ${data.trans_date.split(' ')[0]}`, 370, y);
    
    y -= 15;
    drawText(`${data.billing_country} - ${data.billing_zip}`, 50, y);
    data.delivery_address && drawText(`${data.delivery_country}, ${data.delivery_zip}`, 200, y);
    drawText(`Due Date : ${data.trans_date.split(' ')[0]}`, 370, y);

    y -= 15;
    drawText(`${data.billing_tel}`, 50, y);
    data.delivery_tel && drawText(`${data.delivery_tel}`, 200, y);
   
    // Divider
    y -= 20;
    page.drawLine({ start: { x: 50, y }, end: { x: width - 50, y }, thickness: 1, color: rgb(0, 0, 0) });

    
    // Table headers
    y -= 20;
    drawBoldText('PRODUCT', 50, y);
    drawBoldText('DESCRIPTION', 150, y);
    drawBoldText('UNIT PRICE', 380, y);
    drawBoldText('AMOUNT', 500, y);

    // Line item
    y -= 20;
    drawText(`${props.subData.productName}`, 50, y);
    drawText(`${props.subData.productDesc}`, 150, y);
    drawText(`INR ${data.amount}`, 380, y);
    drawText(`INR ${data.amount}`, 500, y);

    y -= 12;
    // drawText(`${props.subData.productName}`, 50, y);
    drawText(`(${new Date(props.subData.created)?.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} - ${new Date(props.subData.expiry)?.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })})`, 150, y);
    // drawText(`INR ${amount}`, 380, y);
    // drawText(`INR ${amount}`, 500, y);

    // Totals
    y -= 40;
    page.drawLine({ start: { x: 380, y : y-5 }, end: { x: width - 50, y : y-5 }, thickness: 1, color: rgb(0.9, 0.9, 0.9) });
    drawText('Subtotal', 380, y);
    drawText(`INR ${data.amount}`, 500, y);
    page.drawLine({ start: { x: 380, y : y-5 }, end: { x: width - 50, y : y-5 }, thickness: 1, color: rgb(0.9, 0.9, 0.9) });
    
    // y -= 15;
    // drawText('Sales Tax 0%', 380, y);
    // drawText('INR 0.00', 500, y);
    y -= 15;
    drawBoldText('Total', 380, y);
    drawBoldText(`INR ${data.amount}`, 500, y);
    page.drawLine({ start: { x: 380, y : y-5 }, end: { x: width - 50, y : y-5 }, thickness: 1, color: rgb(0.9, 0.9, 0.9) });
    
    
    // Bottom blue bar
    // page.drawRectangle({ x: 0, y: 20, width, height: 20, color: rgb(0.3, 0.5, 0.8) });

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `invoice-${props.subData.id}-${data.order_id}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };


  return (
    <div className="max-w-5xl mx-auto p-2">
      <h2 className="text-2xl font-semibold text-center mb-2">Payment History</h2>
      {!props.paymentData ?<div className="p-6 text-red-600 text-xl w-full flex justify-center w-full">No payment history available.</div>
      :<div className="overflow-y-auto md:max-h-[70vh] lg:max-h-[80vh] pr-2">
        {Object.keys(props.paymentData)?.reverse().map((id) => {
          const data = props.paymentData[id];
          const showDownload = data.order_status === "Success";
          return (
            <div
              key={id}
              className="border border-gray-200 rounded-lg shadow-sm p-2 mb-2 bg-white"
            >
              <div className="flex flex-col md:flex-row justify-between gap-4">
                <div>
                  <p className="text-sm text-gray-500">Order ID</p>
                  <p className="text-md font-medium">{data.order_id}</p>

                  <div className="mt-2 flex items-center gap-2 flex-wrap">
                    <div>
                      <p className="text-sm text-gray-500">Amount</p>
                      <p className="text-md font-medium">
                        ₹{data.amount} {data.currency}
                      </p>
                    </div>
                    <span
                      className={`text-sm px-3 py-1 mt-5 md:mt-0 rounded-full ${getStatusClass(
                        data.order_status
                      )}`}
                      title={data.status_message}
                    >
                      {data.order_status}
                    </span>
                  </div>

                  <p className="text-sm text-gray-500 mt-2">Date</p>
                  <p className="text-md font-medium">{data.trans_date}</p>
                </div>

                <div className="flex flex-wrap items-start md:items-center gap-2 md:gap-4 mt-2 md:mt-0 justify-end">
                  {showDownload && (
                    <div className="flex greenbutton cursor-pointer" onClick={() => generatePDF(id)}>
                      <Download className={"mt-1 ml-3 mr-1"}width={"30"} height={"30"} /> Invoice
                    </div>
                  )}
                  <button
                    className="px-2 py-1 text-sm border border-gray-400 rounded hover:bg-gray-100"
                    onClick={() => toggleExpand(id)}
                  >
                    {expandedIndex === id ? "Hide" : "Show"} Address {expandedIndex === id ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                  </button>
                </div>
              </div>

              {expandedIndex === id && (
                <div className="mt-2">
                  <h4 className="text-lg font-semibold mb-2 border-b pb-1">
                    Addresses
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-2 rounded border">
                      <p className="font-semibold mb-1">Billing Address</p>
                      <p className="text-sm text-gray-700 leading-5">
                        {data.billing_name}
                        <br />
                        {data.billing_address}
                        <br />
                        {data.billing_city}, {data.billing_state} -{" "}
                        {data.billing_zip}
                        <br />
                        {data.billing_country}
                        <br />
                        Email: {data.billing_email}
                        <br />
                        Phone: {data.billing_tel}
                      </p>
                    </div>

                    <div className="bg-gray-50 p-2 rounded border">
                      <p className="font-semibold mb-1">Delivery Address</p>
                      <p className="text-sm text-gray-700 leading-5">
                        {data.delivery_name}
                        <br />
                        {data.delivery_address}
                        <br />
                        {data.delivery_city}, {data.delivery_state} -{" "}
                        {data.delivery_zip}
                        <br />
                        {data.delivery_country}
                        <br />
                        Phone: {data.delivery_tel}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>}
    </div>
  );
};

export default PaymentHistory;
